// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const sectionOrderInKeysItemMax = 80;

export const sectionOrderInKeysMax = 200;

export const SectionOrderIn = zod.object({
  "keys": zod.array(zod.string().max(sectionOrderInKeysItemMax)).max(sectionOrderInKeysMax),
  "revision": zod.int().min(1)
});

export type SectionOrderIn = zod.input<typeof SectionOrderIn>;
export type SectionOrderInOutput = zod.output<typeof SectionOrderIn>;
